import { Dropzone } from '@vendor/libs/dropzone/dropzone';
import Common from '@vendor/js/common';
import { i18n } from '@vendor/libs/lang/lang';
import Utils from '@vendor/js/utils';
import { ConfirmSwal } from '@vendor/libs/sweetalert2/sweetalert2';
import { Spinner } from '@vendor/js/spinner';
import { Api } from '@vendor/js/api';
const _FileInputComponentHandler = (function () {
    return {
        getContainer(name) {
            return $(`[data-app-dropzone="${name}"]`);
        },
        setProgressFinished(name, id, error = false, message = '') {
            const progressElement = this.getContainer(name).find(`tr[data-app-id="${id}"] [data-app-progress]`);
            progressElement.show();
            progressElement.find('.progress').hide();
            const progressBarFinished = progressElement.find('[data-app-progress-finished]');
            progressBarFinished.show();
            if (error) {
                progressBarFinished
                    .find('[data-app-upload="error"]')
                    .show();
                progressBarFinished
                    .find('[data-app-upload="success"]')
                    .hide();
                progressBarFinished
                    .find('[data-app-upload="error"] small')
                    .text(message);
            }
            else {
                progressBarFinished
                    .find('[data-app-upload="success"]')
                    .show();
                progressBarFinished
                    .find('[data-app-upload="error"]')
                    .hide();
            }
        },
        showProgress(name, progress, id) {
            const progressElement = this.getContainer(name).find(`tr[data-app-id="${id}"] [data-app-progress]`);
            progressElement.show();
            progressElement.find('.progress').show();
            const progressBarElement = progressElement.find('.progress-bar');
            const progressBarFinished = progressElement.find('[data-app-progress-finished]');
            progressBarFinished.hide();
            progressBarElement
                .css({ width: `${progress}%` })
                .text(`${progress.toFixed(2)}%`);
        },
        hideProgress(name, id) { },
        addOrUpdateRow(name, id, data) {
            const html = Common.compileTemplate('file_row', data);
            const row = this.getContainer(name).find(`tr[data-app-id="${id}"]`);
            if (row.length) {
                row.replaceWith(html);
                return;
            }
            this.getContainer(name).find('table tbody').append(html);
            this.handleEmptyTableIndicator(name);
        },
        handleEmptyTableIndicator(name) {
            const container = this.getContainer(name);
            if (container.find('tr[data-app-id]').length) {
                container.find('tr[data-app-empty]').hide();
            }
            else {
                container.find('tr[data-app-empty]').show();
            }
        },
        removeRow(name, id, multiple) {
            const row = this.getContainer(name).find(`tr[data-app-id="${id}"]`);
            if (row.length) {
                row.remove();
            }
            if (!multiple) {
                this.showDropZone(name);
            }
            this.handleEmptyTableIndicator(name);
        },
        showDropZone(name) {
            this.getContainer(name).find('.dropzone-zone').closest('.col-12').show();
        },
        hideDropZone(name) {
            this.getContainer(name).find('.dropzone-zone').closest('.col-12').hide();
        },
        handleFileInput(name, uploadUrl, o = {}) {
            let options = Utils.setDefaults(o, {
                multiple: false,
                maxSize: 256,
            });
            const form = $(`[name="${name}"]`).closest('form');
            const container = this.getContainer(name);
            const handler = this;
            new Dropzone('#dropzone', {
                url: uploadUrl,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                previewTemplate: '<div class="d-none"></div>',
                paramName: 'attachment',
                multi: true,
                maxFilesize: options.maxSize,
                init: function () {
                    const idInput = document.querySelector('input[name="id"]');
                    this.on('sending', function (file, xhr, formData) {
                        // Append the id to the formData
                        if (idInput) {
                            formData.append('parentId', idInput.value);
                        }
                    });
                    this.on('complete', function () {
                        // handler.setProgressFinished(name);
                    });
                    this.on('addedfile', (file) => {
                        if (!options.multiple) {
                            handler.getContainer(name).find('tbody').empty();
                            handler.hideDropZone(name);
                            handler
                                .getContainer(name)
                                .find('[data-app-input="container"]')
                                .hide();
                            Common.clearFormInputError(form, name);
                        }
                        handler.addOrUpdateRow(name, file.upload?.uuid ?? '', {
                            id: file.upload?.uuid ?? '',
                            name: file.name,
                        });
                    });
                    this.on('uploadprogress', function (file, progress) {
                        handler.showProgress(name, progress, file.upload?.uuid ?? '');
                    });
                    this.on('error', (file, response) => {
                        let errorMessage = '';
                        if (response && response.message) {
                            errorMessage = response.message;
                        }
                        handler.setProgressFinished(name, file.upload?.uuid ?? '', true, errorMessage);
                        if (!options.multiple) {
                            handler.showDropZone(name);
                        }
                    });
                    this.on('success', function (file) {
                        handler.setProgressFinished(name, file.upload?.uuid ?? '');
                        if (!file.xhr) {
                            return;
                        }
                        const response = JSON.parse(file.xhr.responseText);
                        handler.addOrUpdateRow(name, file.upload?.uuid ?? '', {
                            id: response.data.id.toString(),
                            name: response.data.name,
                            thumbnail: response.data.thumbnail,
                            withActions: true,
                            withDelete: typeof options.deleteUrl != 'undefined',
                            withPreview: typeof options.showUrl != 'undefined',
                            showUrl: options.showUrl.replace('FILE_ID', response.data.id.toString()),
                        });
                        handler.setProgressFinished(name, response.data.id.toString());
                    });
                },
            });
            handler
                .getContainer(name)
                .on('click', '[data-app-file="delete"]', async function (e) {
                e.preventDefault();
                if (options.deleteUrl) {
                    ConfirmSwal.fire({
                        text: i18n.trans('common.forms.files.delete_confirmation'),
                    }).then(async (response) => {
                        if (response.isConfirmed) {
                            const spinner = new Spinner();
                            const id = $(this).attr('data-app-id') ?? '';
                            try {
                                const response = await Api.delete(options.deleteUrl.replace('FILE_ID', id));
                                if (response.success) {
                                    handler.removeRow(name, id, options.multiple);
                                }
                            }
                            catch (error) {
                                Common.handleErrorResponse(error);
                            }
                            finally {
                                spinner.destroy();
                            }
                        }
                    });
                }
            });
        },
    };
})();
window.FileInputComponentHandler = _FileInputComponentHandler;
